var _style, _g, _path, _path2, _path3, _rect, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartner01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 70",
    style: {
      enableBackground: "new 0 0 100 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA2330;}\r\n\t.st1{opacity:0.7;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_4_);}\r\n\t.st5{fill:url(#SVGID_5_);}\r\n\t.st6{fill:url(#SVGID_6_);}\r\n\t.st7{clip-path:url(#SVGID_7_);}\r\n\t.st8{fill:#072F54;}\r\n\t.st9{fill:#FBC108;}\r\n\t.st10{fill:#525A68;}\r\n\t.st11{fill:#5C0D34;}\r\n\t.st12{fill:#757F8B;}\r\n\t.st13{fill:#F48F00;}\r\n\t.st14{fill:#007FAD;}\r\n\t.st15{fill:#C94A30;}\r\n\t.st16{fill:#CDD0D2;}\r\n\t.st17{fill:none;}\r\n\t.st18{fill:#4272FC;}\r\n\t.st19{fill:#231F20;}\r\n\t.st20{fill:#DB3939;}\r\n\t.st21{fill:#FF5A5F;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.39,40.7c0.66-0.11,1.31,0.46,1.45,1.29c0.14,0.83-0.27,1.61-0.93,1.72H57.9c-0.69,0.13-1.39,0.2-2.1,0.2 c-1.47,0-2.65-0.35-3.57-1.06c-1.18-0.9-1.8-2.33-1.8-4.12V22.21c0-0.67,0.69-1.21,1.53-1.21c0.84,0,1.53,0.54,1.53,1.21v16.54 c0,0.81,0.2,1.38,0.61,1.69c0.36,0.28,1.24,0.63,3.27,0.27L57.39,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.47,42.48c-0.55,0-1.08-0.81-1.35-1.34c-1.42-2.76-2.51-4.97-3.37-6.74c-1.77-3.62-2.73-5.34-3.52-5.95 c-0.8-0.61-0.96-1.41-0.58-2.11c0.4-0.72,1.31-0.98,2.03-0.58c0.01,0,0.01,0.01,0.02,0.01c1.7,0.97,2.59,2.78,4.8,7.29 c0.86,1.75,1.92,3.93,3.32,6.64c0.35,0.67,0.59,2.03-0.02,2.47L26.47,42.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.29,35.92c0-4.02-3.26-7.27-7.27-7.27h-6.43c-0.67,0-1.21-0.69-1.21-1.53c0-0.84,0.54-1.53,1.21-1.53h6.43 c5.71,0,10.33,4.63,10.33,10.33l0,0v6.81c0,0.67-0.69,1.21-1.53,1.21c-0.84,0-1.53-0.54-1.53-1.21L62.29,35.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.95,37.85v0.16c0,1.74-1.41,2.87-3.63,2.87s-3.64-1.13-3.64-2.87c0-1.74,1.43-2.88,3.64-2.88h0.13 c2.31,0,6.29,1.06,6.57,1.15v-2.91c-1.47-0.52-3.83-1.3-6.57-1.3h-0.13c-4.1,0-6.7,2.66-6.7,5.93c0,3.27,2.6,5.93,6.7,5.93 s6.7-2.65,6.7-5.93v-0.15l-0.01-6.35c0-3.27-3.16-5.93-6.69-5.93l-0.59-0.01c-4.66,0-8.31,1.26-10.98,7.42 c-0.22,0.5-0.42,1-0.62,1.5l-0.03,0.07c-0.64,1.58-1.01,2.73-1.93,4.86c-1.72,3.98-3.27,6.3-5.62,6.44 c-1.27,0.07-1.59,0.92-1.43,1.77C19.27,48.49,19.8,49,20.54,49c3.83,0,6.23-3.53,8.52-8.55l0.03-0.06 c0.35-0.82,0.68-1.67,1.03-2.55c0.46-1.18,0.93-2.41,1.45-3.62c2.04-4.7,4.35-5.57,8.16-5.57h0.59c1.63,0,3.63,1.13,3.63,2.87 v6.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.49,37.85v0.16c0,1.74-1.43,2.87-3.65,2.87s-3.64-1.13-3.64-2.87c0-1.74,1.43-2.88,3.64-2.88h0.14 c2.31,0,6.29,1.06,6.57,1.15v-2.91c-1.47-0.52-3.84-1.3-6.57-1.3h-0.14c-4.1,0-6.7,2.66-6.7,5.93c0,3.27,2.6,5.93,6.7,5.93 c4.1,0,6.7-2.65,6.7-5.93v-0.15l-0.01-6.35c0-3.27-3.16-5.92-6.69-5.92c0,0-1.1-0.01-1.33-0.01c-7.53,0-12.23,4.91-12.23,11.71 h3.06c0-5.1,3.33-8.65,9.17-8.65c0.27,0,1.12,0.01,1.12,0.01c2.2,0,3.86,1.11,3.86,2.85L79.49,37.85L79.49,37.85z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.6073,
    y1: 62.2474,
    x2: 220.1266,
    y2: 70.8656,
    gradientTransform: "matrix(1 0 0 -1 -175.08 106.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#DFDFE0",
      stopOpacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#88898A",
      stopOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#666769",
      stopOpacity: 0.8
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.95,35.57v2.44c0,1.36-0.87,2.35-2.31,2.71v3.12c3.33-0.51,5.38-2.92,5.38-5.83v-0.15v-1.57 C46.66,36.2,44.82,35.79,43.95,35.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.1384,
    y1: 62.246,
    x2: 255.6622,
    y2: 70.8936,
    gradientTransform: "matrix(1 0 0 -1 -175.08 106.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#DFDFE0",
      stopOpacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#88898A",
      stopOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666769",
      stopOpacity: 0.8
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.49,35.57v2.44c0,1.36-0.88,2.36-2.33,2.72v3.11c3.33-0.51,5.38-2.92,5.38-5.83v-0.15V36.3 C82.19,36.2,80.36,35.79,79.49,35.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.65,
    y1: 77.0692,
    x2: 238.8944,
    y2: 74.0658,
    gradientTransform: "matrix(1 0 0 -1 -175.08 106.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#DFDFE0",
      stopOpacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#88898A",
      stopOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666769",
      stopOpacity: 0.8
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.78,25.62v3.07c3.7,0.4,6.5,3.51,6.5,7.23v0.37h0.04c0.11-1.92,0.69-3.79,1.69-5.44 C62.32,27.84,59.23,25.88,55.78,25.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 51.9645,
    y1: 275.5926,
    x2: 51.9645,
    y2: 283.3531,
    gradientTransform: "matrix(1 0 0 -1 0 312)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#DFDFE0",
      stopOpacity: 0.17
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#88898A",
      stopOpacity: 0.62
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666769",
      stopOpacity: 0.8
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.43,
    y: 28.65,
    className: "st5",
    width: 3.06,
    height: 7.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.8708,
    y1: 74.3566,
    x2: 201.5071,
    y2: 66.6036,
    gradientTransform: "matrix(1 0 0 -1 -175.08 106.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#F0F0F1",
      stopOpacity: 0.07
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#8D8D8F",
      stopOpacity: 0.52
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#666769",
      stopOpacity: 0.7
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M21.75,34.4c0.87,1.77,1.95,3.98,3.37,6.74c0.04,0.08,0.09,0.16,0.14,0.25c0.29-0.6,0.6-1.25,0.9-1.96 c0.27-0.62,0.49-1.15,0.68-1.64c-0.94-1.85-1.7-3.42-2.35-4.73L21.75,34.4z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner01);
export default __webpack_public_path__ + "static/media/partner-01.5cbb8db20a83a7aea83a8661a01612d7.svg";
export { ForwardRef as ReactComponent };